<template>
  <div class="gw_paginated_search gwppsrch">
    <GwInputNew
      :placeholder="$t(`common.search`)"
      @update:value="handleSearchInput"
    />
    <div
      class="gwppsrch_results small-scroll-track"
      @scroll="handleScroll"
    >
      <slot
        name="results"
        :items="items"
      ></slot>

      <LoaderSpinner
        v-if="search_call.loading"
        class="gwppsrch_results_loader my-auto"
        data-tst="gw_paginated_search_loader"
        style="margin: 1rem auto; --size: 2rem"
      />

      <IconAndText
        v-else-if="search_call.error"
        class="pa-4"
        icon="mdi-alert-circle-outline "
        style="--icon-size: 3rem; --icon-color: var(--clr-error)"
        :title="$t('messages.oops_error')"
      >
        <div
          class="gw_btn weight_500 mt-4 mx-auto"
          @click="handleSearchInput('')"
        >
          <i class="mr-2 mdi mdi-refresh text-large"></i>
          {{ $t('btn.retry') }}
        </div>
      </IconAndText>
      <IconAndText
        v-else-if="!items.length"
        class="pa-4 my-auto"
        icon="mdi-alert-circle-outline "
        style="--icon-size: 3rem; --icon-color: var(--clr-black-4)"
        :title="$t('messages.no_results_were_found')"
      >
      </IconAndText>
    </div>
  </div>
</template>

<script>
import fetch_mix from '@/mixins/fetch_mix'
import { throttle } from 'lodash'
import GwInputNew from '@/components/lib/GwInputNew.vue'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import IconAndText from '@/components/Poker/Overlays/IconAndText'

export default {
  name: 'GwPaginatedSearch',
  components: {
    GwInputNew,
    LoaderSpinner,
    IconAndText,
  },
  mixins: [fetch_mix],
  props: {
    endpoint: { required: true, type: String },
    immediate: { default: false },
    searchKey: { default: 'search' },
    dataHandler: Function,
    callConfig: {
      default: () => ({
        apiVersion: 'v2',
        waitForCache: true,
        gwCacheAdd: true,
        gwCacheInvalidate: true,
      }),
    },
  },
  data() {
    return {
      inputValue: '',

      search_call: {
        conf: {},
        loading: false,
        loaded: false,
        status: 0,
      },

      items: [],
      offset: 0,
      limit: 50,
      next: true,
    }
  },
  created() {
    if (this.immediate) {
      this.getData()
    }
  },
  methods: {
    reset() {
      this.items = []
      this.offset = 0
      this.limit = 50
      this.next = true
    },
    handleSearchInput(str) {
      if (this.inputValue === str.trim()) return
      this.inputValue = str.trim()

      this.reset()
      this.getData()
    },
    handleScroll(e) {
      const el = e.target
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        this.offset += this.limit
        this.getData()
      }
    },
    getData: throttle(() => {
      this._getData()
    }, 444),
    async _getData() {
      if (!this.next) return
      if (this.search_call.loading) return

      const { endpoint } = this
      this.search_call.conf = {
        endpoint,
        params: {
          offset: this.offset,
          limit: this.limit,
          [this.searchKey]: this.inputValue,
        },
        ...this.callConfig,
      }
      const { data, error } = await this.fch_getData(this.search_call)
      if (error) {
        this.error = error
        return
      }

      const l_data = this.dataHandler ? this.dataHandler({ data }) : data
      this.items = [
        ...this.items, //
        ...(l_data || []),
      ]
      this.next = data?.next || !!l_data?.[0]
    },
  },
}
</script>
<style lang="scss" scoped>
.gwppsrch {
  --gwsearch-input-height: 2rem;
  --gwsearch-input-radius: 6px;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 0;
  min-width: 0;
  max-height: 100%;
  flex: 1;
  overflow: hidden;
  gap: 1rem;
  &_input {
    padding: 0 2rem;
  }
  &_icon {
    position: absolute;
    left: 0.5rem;
    font-size: 1.25em;
  }
  &_clear {
    font-size: 1.25em;
    position: absolute;
    right: 0.25rem;
    cursor: pointer;
  }
  &_results {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 14rem;
    position: relative;
  }
}
</style>
